import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    clubActivityId: String,
    justLoggedIn: Boolean,
  };

  connect() {
    if (this.justLoggedInValue) {
      this.#processPendingFavorite();
    }
  }

  open(event) {
    event.preventDefault();
    sessionStorage.setItem("pending_favorite_id", this.clubActivityIdValue);
    sessionStorage.setItem("pending_favorite_return_url", window.location.href);
    document.getElementById("auth-modal-backdrop").classList.remove("hidden");
  }

  #processPendingFavorite() {
    const pendingId = sessionStorage.getItem("pending_favorite_id");
    if (!pendingId) return;

    const returnUrl = sessionStorage.getItem("pending_favorite_return_url");
    sessionStorage.removeItem("pending_favorite_id");
    sessionStorage.removeItem("pending_favorite_return_url");

    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    fetch("/favorites", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": token,
      },
      body: new URLSearchParams({ club_activity_id: pendingId }),
    }).then(() => {
      if (returnUrl) window.location.href = returnUrl;
    });
  }
}
